import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  FranchiseEnquiryPayload,
  FranchiseEnquiryRecord,
} from "@project/types/gruh-udhyog";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/franchise-enquiries`;
const SILENT: RequestConfig = { showNotification: false };

class FranchiseEnquiryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<FranchiseEnquiryRecord>> => {
    return fetchListPage<FranchiseEnquiryRecord>(`${BASE}/`, query);
  };

  get = async (
    id: number
  ): Promise<FranchiseEnquiryRecord | undefined> => {
    const data = await get<
      ApiItemResponse<FranchiseEnquiryRecord> | FranchiseEnquiryRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (payload: FranchiseEnquiryPayload): Promise<FranchiseEnquiryRecord> => {
    const response = await axiosConfig.post<
      ApiItemResponse<FranchiseEnquiryRecord> | FranchiseEnquiryRecord
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      return response.data as FranchiseEnquiryRecord;
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<FranchiseEnquiryPayload>
  ): Promise<FranchiseEnquiryRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<FranchiseEnquiryRecord> | FranchiseEnquiryRecord,
      Partial<FranchiseEnquiryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const franchiseEnquiryService = new FranchiseEnquiryService();
